import { render, staticRenderFns } from "./setting-watermarkImage.vue?vue&type=template&id=4f93ed7e&scoped=true&"
import script from "./setting-watermarkImage.vue?vue&type=script&lang=js&"
export * from "./setting-watermarkImage.vue?vue&type=script&lang=js&"
import style0 from "./setting-watermarkImage.vue?vue&type=style&index=0&id=4f93ed7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f93ed7e",
  null
  
)

export default component.exports